import { UsersApi } from "./api"
import { EditUserCtrl } from "./edit/edit"
import { EditUserHoldingsCtrl } from "./holdings/holdings"
import { UserMenuCtrl } from "./menu/menu"
import { ChangePasswordCtrl } from "./password/password"

/// <reference path="api.ts"/>
/// <reference path="menu/menu.ts" />
/// <reference path="edit/edit.ts" />
/// <reference path="holdings/holdings.ts"/>
/// <reference path="password/password.ts"/>

/** @internal */
export function setUsers(module: ng.IModule) {

    module

        .service("OmniaUserApi", UsersApi)

        .directive("omniaUserMenu", UserMenuCtrl.create)
        .directive("omniaUserEdit", EditUserCtrl.create)
        .directive("omniaUserHoldings", EditUserHoldingsCtrl.create)
        .directive("omniaChangePassword", ChangePasswordCtrl.create)

}
